module.exports = __webpack_public_path__ + "static/media/SF-3-A.2bb8bbea.mp3";